import { camelizeKeys } from 'humps';
import config from '../../../../shared/config/config';
import request from '../../request/request';
import { Subscription } from './subscription-types';

const fetchSubscriptions = async (): Promise<Subscription[] | null> => {
  try {
    const response: Subscription[] = await request.get(config.get('customerAccountAPI.subscriptions'));

    return camelizeKeys(response);
  } catch (error) {
    return null;
  }
};

export default fetchSubscriptions;
